<template>
  <div>
    <div class="card">
      <div class="card-header">
        <div class="col-md-12">
          <ol class="breadcrumb breadcrumb-card-header pull-left">
            <li class="breadcrumb-item">
              <a href="javascript:void(0);" @click="backParent"> Purchasing Type</a>
            </li>
            <li class="breadcrumb-item active">
              <span v-if="purchasingType.id === null">New</span>
              <span v-else>
                {{ purchasingType.name }}
              </span>
            </li>
          </ol>
        </div>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-6">
            <div class="form-group row">
              <label for="name" class="col-sm-3 col-form-label text-left">Name</label>
              <div class="col-sm-9">
                <input type="text" v-model="purchasingType.name" class="form-control"/>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-footer">
        <button type="button" @click="updatePurchasingType" class="btn btn-sm btn-primary pull-right" v-show="purchasingType.id !== null"><i class="fa fa-check" aria-hidden="true"></i> Update</button>
        <button type="button" @click="createPurchasingType" class="btn btn-sm btn-primary pull-right" v-show="purchasingType.id == null"><i class="fa fa-check" aria-hidden="true"></i> Save</button>
        <button type="button" @click="backParent" class="btn btn-sm btn-danger pull-right" v-show="purchasingType.id !== null"><i class="fa fa-reply" aria-hidden="true"></i> Back</button>
      </div>
    </div>
    <!-- <pre>
      {{ purchasingType }}
    </pre> -->
  </div>
</template>

<script>
import axios from 'axios'
import { purchasingTypeUrl, getHeader } from '../../config'

export default {
  name: 'PurchasingTypeForm',
  props: ['purchasingType'],
  methods: {
    backParent: function () {
      this.$emit('backClicked')
    },
    updatePurchasingType () {
      axios.put(purchasingTypeUrl + '/' + this.purchasingType.id, this.purchasingType, { headers: getHeader() })
        .then(response => {
          this.$swal('Purchasing Type', response.data.message, 'success')
          this.$emit('backClicked')
        })
        .catch(error => {
          console.log(error.response)
          this.$swal('Error!!', '', 'error')
        })
    },
    createPurchasingType () {
      axios.post(purchasingTypeUrl, this.purchasingType, { headers: getHeader() })
        .then(response => {
          this.$emit('backClicked')
        })
        .catch(response => {
          console.log(response)
          this.$swal('Error!!', response.data, 'error')
        })
    }
  }
}
</script>
